import { Alert, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Skeleton, TextField } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import { withRouter } from "react-router-dom";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { DefaultProps } from "../LayoutWrapper";

interface State {
    showModal: boolean;
    inProgress: boolean;
    validated: boolean;
    isValid: boolean;
    targetAccountData: any;
}

interface Props extends DefaultProps {
    dataLoaded: boolean;
    playerData: any;
    history: any;
    location: any;
    match?: any;
}

class TransferPlayerWrapped extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            inProgress: false,
            validated: false,
            isValid: false,
            targetAccountData: {}
        };
    }

    showModal = () => {
        this.setState({ showModal: true });
    }

    hideModal = () => {
        this.setState({
            showModal: false,
            validated: false,
            isValid: false,
            targetAccountData: {},
        });
    }

    cancel = () => {
        this.setState({
            showModal: false,
            inProgress: false,
            validated: false,
            isValid: false,
            targetAccountData: {}
        });

        this.props.form.resetFields();
    }

    transferAccount = () => {
        this.props.form.validateFields((error, value) => {
            if (error) {
                return;
            }

            this.setState({ inProgress: true });

            const body = {
                delete_source_account: value.delete_source_account === true,
                target_account_id: value.target_account_id,
            }

            axios.post(`${Config.getInstance.apiUrl}/api/user/${this.props.playerData.id}/transfer`, body,
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                })
                .then(response => {
                    this.setState({ inProgress: false, showModal: false });

                    // Redirect to new player account if deleting source account
                    if (body.delete_source_account) {
                        this.props.history.push("/players/" + body.target_account_id);
                    }
                })
                .catch(_ => {
                    this.setState({ inProgress: false });
                    PopupMessage.error("Something went wrong!");
                });
        });
    }

    checkIfUserExists = (e) => {
        axios.get(`${Config.getInstance.apiUrl}/api/user/${e.target.value}/exists`,
        {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        })
        .then(response => {
            this.setState({
                validated: true,
                isValid: response.data.exists,
                targetAccountData: {
                    name: response.data.name,
                    tag: response.data.tag,
                }
            });
        })
        .catch(_ => {
            PopupMessage.error("Something went wrong!");
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { classes } = this.props;

        if (!this.props.dataLoaded) {
            return <Skeleton width={110} height={55}/>
        }

        return (
            <div>
                <Button disableElevation variant="contained" size="small" onClick={this.showModal}>
                    Transfer profile
                </Button>

                <Dialog
                    open={this.state.showModal}
                    fullWidth={true}
                    maxWidth="sm"
                    onClose={(_, reason) => {
                        if (reason !== "backdropClick") {
                            this.hideModal();
                        }
                    }}
                >
                    <DialogTitle>
                        Transfer account
                    </DialogTitle>

                    <Alert severity="warning">
                        <b>This action cannot be undone!</b> All linked devices to this account will be transferred to target account.
                    </Alert>

                    <DialogContent dividers>
                        <FormGroup>
                            {getFieldDecorator("target_account_id")(
                                <TextField
                                    onBlur={this.checkIfUserExists}
                                    label="Target account id"
                                />
                            )}
                        </FormGroup>

                        {this.state.validated && <div>
                            {this.state.isValid ?
                                <p className="alertText success">Account {this.state.targetAccountData?.name || null} is valid! </p> :
                                <p className="alertText error">Target account is invalid!</p>}
                        </div>}

                        <FormGroup style={{ paddingTop: 10 }}>
                            <FormControlLabel
                                control={
                                    getFieldDecorator("delete_source_account")(
                                        <Checkbox/>
                                    )
                                }
                                label="Delete this account after transfer"
                            />
                        </FormGroup>
                    </DialogContent>

                    <DialogActions>
                        <Button disableElevation
                            onClick={this.cancel}
                            disabled={this.state.inProgress}
                            variant="contained"
                        >
                            Cancel
                        </Button>

                        <div className={classes.wrapper}>
                            <Button disableElevation
                                onClick={this.transferAccount}
                                color="primary"
                                variant="contained"
                                className={classes.loadingButton}
                                disabled={this.state.inProgress}
                            >
                                Transfer
                            </Button>

                            {this.state.inProgress && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const styles: any = theme => ({
    loadingButton: {
        width: "100%",
    },
    wrapper: {
        margin: 8,
        position: "relative",
        marginTop: 10,
        width: 150,
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
});

export const TransferPlayer = createForm()(withStyles(styles)(withRouter(TransferPlayerWrapped)));
